const isProduction =
  (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production') ||
  (typeof __DEV__ !== 'undefined' && __DEV__ === false);

const SECRET_PATTERNS = [
  /eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g,
  /sb_secret_[A-Za-z0-9_-]+/g,
  /Bearer\s+[A-Za-z0-9_.-]+/gi,
  /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g,
];

const PII_KEYS = new Set([
  'password',
  'token',
  'access_token',
  'refresh_token',
  'authorization',
  'auth',
  'jwt',
  'apikey',
  'api_key',
  'secret',
  'email',
  'phone',
  'cpf',
  'rg',
  'content',
  'body',
  'message',
  'note',
  'diary',
  'full_name',
  'first_name',
  'last_name',
  'address',
  'birth_date',
]);

function redactString(value) {
  let s = value;
  for (const pat of SECRET_PATTERNS) {
    s = s.replace(pat, '[REDACTED]');
  }
  return s;
}

function redact(value, depth = 0) {
  if (depth > 6) return '[DEPTH_LIMIT]';
  if (value === null || value === undefined) return value;
  if (typeof value === 'string') return redactString(value);
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  if (value instanceof Error) {
    return { name: value.name, message: redactString(value.message || '') };
  }
  if (Array.isArray(value)) {
    return value.slice(0, 20).map((v) => redact(v, depth + 1));
  }
  if (typeof value === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      if (PII_KEYS.has(k.toLowerCase())) {
        out[k] = '[REDACTED]';
      } else {
        out[k] = redact(v, depth + 1);
      }
    }
    return out;
  }
  return String(value);
}

function safeArgs(args) {
  return args.map((a) => redact(a));
}

const safeLog = {
  info: (...args) => {
    if (isProduction) return;
    console.log(...safeArgs(args));
  },
  debug: (...args) => {
    if (isProduction) return;
    console.log(...safeArgs(args));
  },
  warn: (...args) => {
    console.warn(...safeArgs(args));
  },
  error: (...args) => {
    console.error(...safeArgs(args));
  },
};

module.exports = { safeLog, redact };
module.exports.default = safeLog;
module.exports.safeLog = safeLog;
